<template>
  <pipeline-layout>
    <template v-if="isLoadingRecords">
      <b-loading active></b-loading>
    </template>

    <!--Main Content-->
    <template v-else>
      <template v-if="records.length">
        <p v-if="pastDueRecords.length" class="timeframe-title text-uppercase past_due">
          <icon-default icon="past-due"></icon-default>
          Late Contacting
        </p>
        <lazy-render
          v-for="(record, index) in pastDueRecords"
          :key="record.id"
          :min-height="154"
          :unrender="false"
        >
          <contacting-box
            :delay="index"
            :record="record"
          ></contacting-box>
        </lazy-render>

        <p v-if="todayRecords.length" class="timeframe-title text-uppercase today">
          <icon-default icon="today"></icon-default>
          Contact Today
        </p>
        <lazy-render
          v-for="(record, index) in todayRecords"
          :key="record.id"
          :min-height="154"
          :unrender="false"
        >
          <contacting-box
            :delay="index"
            :record="record"
          ></contacting-box>
        </lazy-render>

        <p v-if="tomorrowRecords.length" class="timeframe-title text-uppercase">
          <icon-default icon="upcoming"></icon-default>
          Contact Tomorrow
        </p>
        <lazy-render
          v-for="(record, index) in tomorrowRecords"
          :key="record.id"
          :min-height="154"
          :unrender="false"
        >
          <contacting-box
            :delay="index"
            :record="record"
          ></contacting-box>
        </lazy-render>

        <p v-if="upcomingRecords.length" class="timeframe-title text-uppercase">
          <icon-default icon="upcoming"></icon-default>
          Contact Later
        </p>
        <lazy-render
          v-for="(record, index) in upcomingRecords"
          :key="record.id"
          :min-height="154"
          :unrender="false"
        >
          <contacting-box
            :delay="index"
            :record="record"
          ></contacting-box>
        </lazy-render>
        <app-loading-section :loading="isLoadingRecords"></app-loading-section>

        <button-outlined
          v-if="nextPageUrl"
          class="my-200 mx-auto"
          size=""
          @click="loadNextPage"
          :loading="showMoreIsLoading"
        >Show More Records</button-outlined>
      </template>
      <empty-records v-else heading="There are no contacting records">
        This is where the leads you are still trying to make initial contact with will reside. You can control the lead
        statuses that show here in the
        <router-link :to="{name: 'settings', params: {tab: 'pipeline'}}">Pipeline Settings</router-link>
      </empty-records>
    </template>

    <!--Filters-->
    <template #filters>
      <p v-if="!isLoadingRecords && records" class="record_count flex flex-vertical-center">
        <span><strong>{{ records.length }}</strong> of <strong>{{ totalRecords }}</strong> leads</span>
      </p>

      <contacting-filters></contacting-filters>
    </template>
  </pipeline-layout>
</template>

<script>
import ContactingBox from "./components/ContactingBox";
import PipelineLayout from "../../components/PipelineLayout";
import ContactingFilters from "./components/ContactingFilters";
import EmptyRecords from "../../components/EmptyRecords";
import LazyRender from "../../../../components/LazyRender"

export default {
  name: "ContactingPipelineDesktop",
  components: {LazyRender, EmptyRecords, ContactingFilters, PipelineLayout, ContactingBox},
  data() {
    return {
      showMoreIsLoading: false
    }
  },
  computed: {
    records() {
      return this.$store.getters["contactingState/records"];
    },
    pastDueRecords() {
      return this.$store.getters["contactingState/pastDueRecords"];
    },
    todayRecords() {
      return this.$store.getters["contactingState/todayRecords"];
    },
    tomorrowRecords() {
      return this.$store.getters["contactingState/tomorrowRecords"];
    },
    upcomingRecords() {
      return this.$store.getters["contactingState/upcomingRecords"];
    },
    filters() {
      return this.$store.getters["contactingState/filters"];
    },
    isLoadingRecords() {
      return this.$store.state.contactingState.isLoadingRecords;
    },
    totalRecords() {
      return this.$store.getters["contactingState/totalRecordsCount"]
    },
    nextPageUrl() {
      return this.$store.getters["contactingState/nextPageUrl"]
    },
  },
  created() {
    this.$store.dispatch("contactingState/setup");
  },
  destroyed() {
    this.$store.dispatch("contactingState/tearDown");
  },
  methods: {
    loadNextPage() {
      this.showMoreIsLoading = true
      this.$store.dispatch("contactingState/loadMoreRecords")
        .finally(() => { this.showMoreIsLoading = false })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.record_count {
  margin-right: 10px;

  span {
    flex: none;
    color: $text-muted;
  }
}

.timeframe-title {
  margin-bottom: 10px;
  font-size: 1.2rem;
  font-weight: bold;

  &:not(:first-child) {
    margin-top: 2rem;
  }

  i {
    vertical-align: bottom;
  }

  &.past_due {
    color: $red;
  }

  &.today {
    color: $yellow;
  }
}
</style>
